module.exports = __webpack_public_path__ + "static/mayankjain-7b07ef051911eac56273d6fcd6a8f17f.jpg";